import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Person, Logout, Login as LoginIcon } from '@mui/icons-material';
import { auth, logout } from '../../utils/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import styles from './HeaderActions.module.css';

interface HeaderActionsProps {
  hospitalId?: string;
}

const HeaderActions: React.FC<HeaderActionsProps> = ({ hospitalId }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const prefix = hospitalId ? `/${hospitalId}` : '';
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  // 로그인 상태 감지
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleMyInfo = () => navigate(`${prefix}/my-info`);
  const handleLogin = () => navigate(`${prefix}/login`);
  
  const handleLogoutClick = async () => {
    const confirmLogout = window.confirm(t('logout_confirm', '로그아웃 하시겠습니까?'));
    if (confirmLogout) {
      await logout();
      localStorage.clear();
      navigate(`${prefix}/`);
    }
  };

  return (
    <div className={styles.buttonGroup}>
      {/* 1. 내 정보 버튼 (항상 노출) */}
      <button className={styles.myInfoButton} onClick={handleMyInfo}>
        <Person fontSize="small" />
        <span>{t('my_information')}</span>
      </button>

      {/* 2. 로그인/로그아웃 상태에 따른 버튼 전환 */}
      {isLoggedIn ? (
        <button className={styles.logoutButton} onClick={handleLogoutClick}>
            {t('logout', '로그아웃')}
        </button>
        ) : (
        <button className={styles.loginButton} onClick={handleLogin}>
            {t('login', '로그인')}
        </button>
      )}
    </div>
  );
};

export default HeaderActions;